import { FC, ReactNode } from 'react';
import { useWindowSize } from '../utils/useWindowSize';

interface IWelcomeSlideProps {
    image: string;
    compactImage?: boolean;
    keyboardOpen?: boolean;
    children: ReactNode;
}

export const WelcomeSlide: FC<IWelcomeSlideProps> = ({ image, compactImage, keyboardOpen, children }) => {
    const { width, height } = useWindowSize();
    const isLandscape = width > height;

    if (isLandscape) {
        return (
            <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', backgroundColor: 'white'}}>
                <div style={{width: '50%', height: '100%', display: 'flex', alignItems: 'center', backgroundColor: '#9CD6EC', padding: 15}}>
                    <img style={{width: '100%', maxWidth: 600, margin: '0 auto', objectFit: 'cover'}} src={`./assets/images/welcome/${image}`} alt="" />
                </div>
                <div style={{width: '50%', maxWidth: 500, margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', height: 350, padding: '24px 40px 40px'}}>
                    {children}
                </div>
            </div>
        );
    }

    const collapseImage = compactImage && keyboardOpen;

    return (
        <div style={{display: 'flex', flexDirection: 'column', width: '100%', height: '100%', backgroundColor: compactImage ? '#9CD6EC' : 'white'}}>
            <div style={{width: '100%', height: collapseImage ? 0 : (compactImage ? '30%' : '50%'), textAlign: 'center', paddingTop: collapseImage ? 0 : 'calc(var(--ion-safe-area-top) - 10px)', overflow: 'hidden', transition: 'height 0.25s ease-out, padding-top 0.25s ease-out, opacity 0.15s ease-out', opacity: collapseImage ? 0 : 1, ...(compactImage ? { flexShrink: 0 } : { backgroundColor: '#9CD6EC' })}}>
                <img style={{height: '100%', objectFit: compactImage ? 'contain' : 'cover'}} src={`./assets/images/welcome/${image}`} alt="" />
            </div>
            <div style={{width: '100%', maxWidth: 500, margin: '0 auto', backgroundColor: 'white', borderRadius: compactImage && !keyboardOpen ? '20px 20px 0 0' : undefined, ...(compactImage ? { flex: 1, overflow: 'auto' } : { height: '50%', borderTop: '1px solid var(--ion-color-step-100)' })}}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: keyboardOpen ? 'flex-start' : 'space-between', minHeight: '100%', width: '100%', padding: '24px 40px 40px'}}>
                    {children}
                </div>
            </div>
        </div>
    );
};
